import { useEffect } from "react";
import { useChurch } from "@/hooks/useChurch";

function setMeta(attr: string, key: string, value: string) {
  let el = document.querySelector(`meta[${attr}="${key}"]`);
  if (el) {
    el.setAttribute("content", value);
  } else {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    el.setAttribute("content", value);
    document.head.appendChild(el);
  }
}

/** Updates document meta / OG tags to reflect the current church profile. */
export default function DynamicOgMeta() {
  const { profile } = useChurch();

  useEffect(() => {
    if (!profile) return;

    const title = `${profile.church_name} — iChurch Data`;
    const description = `${profile.church_name} church management powered by iChurch Data`;
    const image = profile.logo_url || "/ichurch-logo.svg";

    document.title = title;
    setMeta("property", "og:title", title);
    setMeta("property", "og:description", description);
    setMeta("property", "og:image", image);
    setMeta("name", "twitter:title", title);
    setMeta("name", "twitter:description", description);
    setMeta("name", "twitter:image", image);
    setMeta("name", "description", description);
  }, [profile]);

  return null;
}
